import { useState, useEffect } from "react";
import API from "../../../../config/api.js";
import { imageToDataUrl } from "../utils.js";

export function useRecipePosterData(
  token,
  selectedRecipe,
  setSelectedRecipe,
  setError,
) {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [preloadedImageUrl, setPreloadedImageUrl] = useState(null);

  useEffect(() => {
    if (!token) return;
    const fetchRecipes = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API.baseURL}/recipes?mine=1`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          const list = data.data || [];
          setRecipes(list);
          if (list.length > 0 && !selectedRecipe) setSelectedRecipe(list[0]);
        }
      } catch (err) {
        setError(err.message || "Erreur chargement");
      } finally {
        setLoading(false);
      }
    };
    fetchRecipes();
  }, [token, selectedRecipe, setSelectedRecipe]);

  useEffect(() => {
    const imgUrl = selectedRecipe?.image_url || selectedRecipe?.image;
    if (!imgUrl) {
      setPreloadedImageUrl(null);
      return;
    }
    if (imgUrl.startsWith("data:")) {
      setPreloadedImageUrl(imgUrl);
      return;
    }
    let cancelled = false;
    imageToDataUrl(imgUrl).then((dataUrl) => {
      if (!cancelled) setPreloadedImageUrl(dataUrl);
    });
    return () => {
      cancelled = true;
    };
  }, [selectedRecipe?.id, selectedRecipe?.image_url, selectedRecipe?.image]);

  return { recipes, loading, preloadedImageUrl, setRecipes };
}
